import React, { FC, memo } from 'react';
import { Select, Space } from 'udesk-ui';
import InfoEntitySelect from 'src/components/common/InfoEntitySelect';
import RandomFieldSelectList from './components/RandomFieldSelectList';
import { FieldFoundResponse, InformationEntity } from 'src/api/types';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    value?:
        | {
              keyType?: 1;
              value?: InformationEntity;
          }
        | {
              keyType?: 2;
              value?: FieldFoundResponse[];
          };
    onChange?: (value: TemplateProps['value']) => void;
    dataSourceList?: number[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, dataSourceList } = props;

    const onKeyTypeChange = (v: 1 | 2) => {
        const newValue = {
            ...value,
            keyType: v,
            value: undefined,
        };
        onChange?.(newValue);
    };

    const onValueChange = (v: any) => {
        const newValue = {
            ...value,
            value: v,
        };
        onChange?.(newValue);
    };

    return (
        <Space>
            <Select
                value={value?.keyType}
                onChange={(v) => onKeyTypeChange(v)}
                options={[
                    {
                        value: 1,
                        label: /* 信息实体 */UdeskLocales['current'].pages.semanticIntelligence.externalInterface.detail.components.paramsList.components.valueSpecial1.index.informationEntity,
                    },
                    {
                        value: 2,
                        label: /* 随路字段 */UdeskLocales['current'].pages.semanticIntelligence.externalInterface.detail.components.paramsList.components.valueSpecial1.index.followthepathField,
                    },
                ]}
                style={{ width: 100 }}
            />

            {value?.keyType === 1 ? (
                <InfoEntitySelect
                    value={value?.value}
                    onChange={(v) => onValueChange(v)}
                    style={{ width: 200 }}
                />
            ) : value?.keyType === 2 ? (
                <RandomFieldSelectList
                    value={value?.value}
                    onChange={(v) => onValueChange(v)}
                    dataSourceList={dataSourceList}
                    maxWidth={410}
                />
            ) : null}
        </Space>
    );
});

export default Template;
